module.exports = __webpack_public_path__ + "82bf2c3e5a528cee1c488c88391115d5.jpg";